import HashMap from 'hashmap';
import common from '@/commons/webSocketCommon/mqUtils/common.js';
let socketInfoMap = new HashMap(); //socket 链接信息
let socketClientMap = new HashMap(); //socket 链接对象
let subscribeMap = new HashMap(); //订阅map
let callbackMap = new HashMap(); //回调map
let loginStateMap = new HashMap(); //登录状态
function websocketonMessage(e) {
    if (e.data) {
        let data = JSON.parse(e.data);
        let cmd = data.cmd;
        let communicationId = data.communicationId;
        if (callbackMap.has(communicationId)) {
            callbackMap.get(communicationId)(data);
            callbackMap.remove(communicationId);
            return false;
        } else if (callbackMap.has(cmd)) {
            callbackMap.get(cmd)(data);
            callbackMap.remove(cmd);
            return false;
        } else {
            if (subscribeMap.has(cmd)) {
                subscribeMap.get(cmd)(data);
            }
        }
    }
}
//发送信息
function websocketsend(socketId, agentData, callback) {
    let socketIds = socketClientMap.get(socketId);
    let agentDatas = JSON.stringify(agentData);
    socketIds.send(agentDatas);
    if (callback && '' != callback) {
        let communicationId = agentData.communicationId;
        if (communicationId && '' != communicationId) {
            callbackMap.set(communicationId, callback);
        } else {
            callbackMap.set(Number(10000) + Number(agentData.cmd), callback);
        }
    }
    let returnInfo = {
        description: window.vue.$t('returnInfo.REQUEST_SUCCESS'),
        ret: window.vue.$t('returnInfo.SUCCESS')
    };
    return returnInfo;
}
//链接websocket
function clientWebSocket(socketInfo) {
    if (socketInfo.url == '' || socketInfo.agentId == '' || socketInfo.token == '') {
        console.info('传参不对,请检查参数');
        return false;
    }
    let websocketObj = new WebSocket(socketInfo.url);
    socketClientMap.set(socketInfo.agentId, websocketObj);
    websocketObj.onmessage = function(e) {
        websocketonMessage(e);
    };
    websocketObj.onclose = function(e) {
        window.vue.$log.debug('connection closed (' + e.code + ')');
    };
    websocketObj.onopen = function() {
        window.vue.$log.debug('连接成功');
        login(socketInfo);
    };
    //连接发生错误的回调方法
    websocketObj.onerror = function(e) {
        console.info('连接失败');
        window.vue.$log.error('WebSocket连接发生错误:' + socketInfo.agentId, e);
    };
}
//处理登录回调
function loginMsg(data) {
    if (data.param.ret == 0) {
        let token = sessionStorage.getItem('token');
        if (window.vue.$util.isEmpty(token)) {
            token = sessionStorage.getItem('initWebSocketToken');
        }
        console.info('处理登录回调');
        window.vue.$EventBus.$emit('webSocketLoginSuccessEvent');
        let agentId = data.agentId;
        let socketIds = socketClientMap.get(agentId);
        let updateSocketInfo = JSON.parse(sessionStorage.getItem('socketInfo'));
        let targetUpdataParame = updateSocketInfo.updataParame;
        let coo = document.cookie;
        let index = coo.lastIndexOf('tiandy_jp_language');
        let language = 'CN';
        if (index > 0) {
            language = coo.substring(index + 19, index + 21);
            if (language == 'zh') {
                language = 'CN';
            }
        }
        if (targetUpdataParame != undefined && targetUpdataParame != '') {
            let updataParame = {
                agentId: agentId,
                platform:
                    window.location.protocol +
                    '//' +
                    window.location.hostname +
                    (window.location.port ? ':' + window.location.port : '') +
                    '/' +
                    JSON.parse(sessionStorage.getItem('socketInfo')).platform,
                token: token,
                sender: targetUpdataParame.sender,
                cmd: parseInt(targetUpdataParame.cmd),
                clientlist: [targetUpdataParame.clientlist],
                param: {
                    platIp: window.config.host.split('/')[2].split(':')[0],
                    platPort: parseInt(window.config.host.split('/')[2].split(':')[1]),
                    versionFileName: [targetUpdataParame.versionFileName],
                    lang: language
                }
            };
            let updataParames = JSON.stringify(updataParame);
            socketIds.send(updataParames);
        }
        loginStateMap.set(agentId, data.param.ret);
    }else if(data.param.ret == 7){
        let updateSocketInfo = JSON.parse(sessionStorage.getItem('socketInfo'));
        setTimeout(login,10000,updateSocketInfo);
    }
}
//登录
function login(socketInfo) {
    let agentId = socketInfo.agentId;
    let token = {
        token: socketInfo.token
    };
    let coo = document.cookie;
    let index = coo.lastIndexOf('tiandy_jp_language');
    let language = 'CN';
    if (index > 0) {
        language = coo.substring(index + 19, index + 21);
        if (language == 'zh') {
            language = 'CN';
        }
    }
    let agentData = {
        agentId: socketInfo.agentId,
        platform: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/' + socketInfo.platform, // platfrom + clientlist 唯一确定一个命令接受者(同一个EXE在同一个平台下只有一个运行)
        token: socketInfo.token,
        checkMode: socketInfo.checkMode,
        sender: socketInfo.sender, //平台名称，固定写platformClient
        cmd: parseInt(socketInfo.cmd), //命令类型 1：启动应用程序/发送命令给应用程序 2：登录通信服务
        clientlist: [
            socketInfo.clientlist //cmd == 2时固定写TerminalServer，cmd == 1时写需要通信的客户端列表
        ],
        param: {
            token: JSON.stringify(token), //平台通过token服务器校验，EXE通过MD5校验（根据name判断，platform是平台）
            url: socketInfo.paramUrl,
            lang: language
        }
    };
    websocketsend(agentId, agentData, loginMsg);
}

//检查websocket链接状态
function checkWebsocket() {
    for (let socketInfo of socketInfoMap.values()) {
        if (socketClientMap.get(socketInfo.agentId).readyState == socketClientMap.get(socketInfo.agentId).CLOSED) {
            socketClientMap.remove(socketInfo.agentId);
            clientWebSocket(socketInfo);
        }
    }
}
setInterval(function() {
    checkWebsocket();
}, 10000);
//数据发送
export default {
    //初始化链接websocket
    initWebSocket(socketInfo) {
        //初始化weosocket
        socketInfoMap.set(socketInfo.agentId, socketInfo);
        let returnInfo = {
            description: window.vue.$t('returnInfo.INIT_SUCCESS'),
            ret: window.vue.$t('returnInfo.SUCCESS')
        };
        clientWebSocket(socketInfo);
        return returnInfo;
    },

    // 发送信息
    send(socketId, agentData, callback) {
        let that = this;
        if (socketClientMap.get(socketId).readyState === socketClientMap.get(socketId).OPEN) {
            //若是ws开启状态
            return websocketsend(socketId, agentData, callback);
        } else if (socketClientMap.get(socketId).readyState === socketClientMap.get(socketId).CONNECTING) {
            // 若是 正在开启状态，则每次等待1s后调用
            setTimeout(function() {
                that.send(socketId, agentData, callback);
            }, 1000);
        } else {
            // 若未连接 ，则返回错误
            let returnInfo = {
                param: {
                    ret: window.vue.$t('returnInfo.NO_CONNECTION_CREATED_CODE'),
                    message: window.vue.$t('returnInfo.NO_CONNECTION_CREATED'),
                    warnmsg: window.vue.$t('returnInfo.VIDEO_PLUG_IN_DETECTION_FAILED')
                }
            };
            callback(returnInfo);
            return returnInfo;
        }
    },
    //订阅消息
    subscribeMessage(cmd, callback) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        subscribeMap.set(cmd, callback);
        returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_SUCCESS'),
            ret: window.vue.$t('returnInfo.SUCCESS')
        };
        return returnInfo;
    },
    //取消订阅
    unsubscribe(msgName) {
        if (msgName && subscribeMap.has(msgName)) {
            subscribeMap.remove(msgName);
        }
        let returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_SUCCESS'),
            ret: window.vue.$t('returnInfo.SUCCESS')
        };
        return returnInfo;
    },
    //断开连接
    close(socketId) {
        if (socketId && socketClientMap.has(socketId)) {
            socketClientMap.get(socketId).close();
            socketInfoMap.remove(socketId);
            socketClientMap.remove(socketId);
            loginStateMap.remove(socketId);
        }
        let returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_SUCCESS'),
            ret: window.vue.$t('returnInfo.SUCCESS')
        };
        return returnInfo;
    }
};
